<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getDataTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in dataTable" :key="item.id">
            <td width="5" align="center">
              {{((dataPaginate.current_page-1)*10)+(index+1)}}
            </td>
            <td width="30%">{{item.message}}</td>
            <td>{{item.email}}</td>
            <td>{{item.phone}}</td>
            <td width="5%" align="center">
              <template v-if="item.is_reply">
                <v-icon class="fas fa-check icon-checked-color"></v-icon>
              </template>
              <template v-else>
                <v-icon class="fas fa-times icon-unchecked-color"></v-icon>
              </template>
            </td>
            <td width="20%">{{item.branch_name}}</td>
            <td width="20%">
              {{item.updated_at | moment('DD-MM-YYYY')}}
            </td>
            <td>
              <a @click="showData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import CircleButton from "../../../components/Button/CircleButton";
    import InputSearch from "../../../components/Input/InputSearch";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import {mapState} from "vuex";
    import {permissionVenueHire, role} from "../../../util/Permission";
    import Paginate from "../../../components/Layout/Paginate";
    import Swal from "sweetalert";
    import Loading from 'vue-loading-overlay';
    export default {
        name: "SupportVenueHireTable",
      components: {Paginate, IconPencil, InputSearch, CircleButton, Loading},
      data(){
          return{
            title : 'Venue Hire Support',
            isLoading : false,
            headers: [
              { id: 1, text: "No." ,'icon' : null},
              { id: 2, text: "Message" ,'icon' : null},
              { id: 3, text: "Email" ,'icon' : null},
              { id: 4, text: "Phone" ,'icon' : null},
              { id: 5, text: "Response" ,'icon' : null},
              { id: 6, text: "Branch" ,'icon' : null},
              { id: 7, text: "Update date" ,'icon' : true},
              { id: 8, text: "Edit" ,'icon' : null}
            ],
            dataTable :[],
            permission : null,
            search : '',
            dataPaginate: {
              current_page: 1,
              from: 1,
              last_page: 1,
              per_page: 1,
              total: 1,
              to: 1
            },
            sort : 'desc',
          }
        },
      created() {
          this.permission = role;
        this.getDataTable(1);
      },
      computed: {
        permissionVenueHire,
        ...mapState({
          form: state => {
            return state.SupportVenueHire.form;
          }
        })
      },
      methods:{
        getDataTable(page){
          this.isLoading = true;
          this.$store.dispatch("SupportVenueHire/getData",{
            page ,
            search : this.search,
            sort : this.sort,
          }).then(res=>{
            if(res.response_code === 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }else{
              Swal(res.response_msg);
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot request data','error');
            this.isLoading = false;
          })
        },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getDataTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToDataEdit(){
          this.$router.push("/customer-support/venue-hire/edit");
        },
        showData(id){
          this.isLoading = true;
          this.$store.dispatch("SupportVenueHire/showData",id).then(res=>{
            if(res.response_code === 200){
              this.$store.dispatch("SupportVenueHire/setFormData",res.result).then(()=>{
                this.goToDataEdit();
              })
            }
            this.isLoading = false;
          })
        },
        clearData(){
          this.$store.dispatch("SupportVenueHire/clearFormData").then(()=>{
            this.goToDataEdit();
          });
        },
        searchInput(val){
          this.search = val;
        },
        sortDataTable(){
          this.sort = this.sort == 'desc' ? 'asc' : 'desc';
          console.log(this.sort);
          this.getDataTable(1);
        }
      },
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/variables.scss";
  .branch-data {
    background-color: $background-theme;
    margin: $margin-search;
  }
  .icon-checked-color {
    color: $submit-color;
    font-size: 20px;
  }
  .icon-unchecked-color {
    color: red;
    font-size: 20px;
  }
</style>
